import { Ellipsis, Image, Swiper } from "antd-mobile";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { envChangeType } from "../../../../plugins/utils";
import { useGetAnnouncementList } from "../../../SystemAnnouncement/hooks/systemAnnoucement.hook";
import styles from "./style.module.scss";
import "./style.scss";

const AnnouncementScroller = ({ announcementContainerStyle = "" }) => {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useGetAnnouncementList();
  const [announcementList, setAnnouncementList] = useState([]);

  useEffect(() => {
    setAnnouncementList(data?.pages[0]?.data || []);
  }, [data]);

  const openAnnouncement = () => {
    navigate("/home/announcement?tab=announce");
  };

  return (
    <div
      className={`${styles.container} ${announcementContainerStyle} announce-container`}
      onClick={openAnnouncement}
    >
      <Image
        src={`images/home/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/message_icon.svg`}
        fallback={<Image src={`images/home/message_icon.svg`} />}
        width={16}
        height={16}
      />
      {isLoading ? (
        ""
      ) : isError ? (
        ""
      ) : (
        <Swiper className={styles.swiper} direction="vertical" autoplay={true} loop={true}>
          {announcementList.map((item) => {
            //remove all line breaks
            const content = item.content.replace(/(\r\n|\n|\r)/gm, "");
            return (
              <Swiper.Item key={item.id}>
                <Ellipsis direction="end" content={content} />
              </Swiper.Item>
            );
          })}
        </Swiper>
      )}
    </div>
  );
};

export default AnnouncementScroller;
